import React from 'react'

export function Home() {
  return (
    <>
      <h4>Home</h4>
    </>
  )
}
